import SendToValidate from './SendToValidate';
export default SendToValidate;
